import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import { stringIsNullOrEmpty } from "../../util/Util";
import { ApiKey, ApiUrl, _MAIN_WALLET_ID } from "../../util/Constant";
import ApiEngine from "../../util/ApiEngine";
import { map } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import {
  setDisplayCommunicationChannel,
  showResponseMessage
} from "../../redux/AppAction";

const LiveChatModal = (props) => {
  const {
    title,
    history,
    url,
    slot,
    state,
    hasBackButton = true,
    hasRightMenu = false,
    rightMenuList = [],
    fromDashboard = false,
    setShowModal = false,
    ...rest
  } = props;
  const { t } = useTranslation();
  const _dispatch = useDispatch();
  let isShowCommunicationChannel = useSelector((state) => state.appState.isShowCommunicationChannel);
  let communicationChannelList = useSelector((state) => state.appState.communicationChannelList);
  const [toggleModal, setToggleModal] = useState(false);
  const [selectedChannel, setSelectedChannel] = useState()

  useEffect(() => {
    if (selectedChannel) {
      if (!stringIsNullOrEmpty(selectedChannel.attachment)) {
        setToggleModal(true);
      }
    }
  }, [selectedChannel]);


  const handleLinkOnClick = async (channel) => {

    if (channel.channelName.match("WeChat") && !stringIsNullOrEmpty(channel.attachment)) {
      setSelectedChannel(channel);
      _dispatch(setDisplayCommunicationChannel(false));
      setToggleModal(true);
    } else {
      setToggleModal(false);
      if (!stringIsNullOrEmpty(channel.cta)) {
        if (window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage(
            JSON.stringify({
              action: "chat",
              url: `${channel.cta}`
            })
          );
        }
        else {
          window.open(channel.cta, "_blank", channel.channelName);
        }
      } else {
        _dispatch(showResponseMessage(false, t("PLEASE_TRY_OTHER_CHANNEL")))
      }
    }

  }


  return (
    <>
      <Modal
        id="custom-modal3"
        contentClassName="modal-brand modal-bottom-live-chat"
        fade={false}
        isOpen={isShowCommunicationChannel}
        toggle={() => {
          _dispatch(setDisplayCommunicationChannel(false));
        }}
        centered
      >
        <ModalBody>
          <form >
            <div className="flex-box-centered mb-1">
              <h2 className="custom-modal-title mb-0 mr-3">{t("WELCOME_TO_LIVECHAT")}</h2>
            </div>
            <hr style={{ borderTop: "1px solid #fff" }}></hr>
            <div className="live-chat-container">
              {communicationChannelList && communicationChannelList.length && map(communicationChannelList, (channel, index) => {
                return (
                  <div key={index} className="live-chat-icon" onClick={() => {
                    handleLinkOnClick(channel)
                  }}>
                  <div className="live-chat-gird">
                    <img src={channel.channelImage} style={{ width: "23px", height: "23px" }}></img>
                    </div>
                    <a style={{ fontSize:"10px" }}>{channel.channelName}
                    </a>
                    </div>
                  )
              })
              }
            </div>
            
          </form>
        </ModalBody>
      </Modal>

      <Modal fade={false} isOpen={toggleModal} toggle={() => { setToggleModal(false) }} centered>
        <ModalHeader toggle={() => { setToggleModal(false) }} style={{ color:"black" }}>{selectedChannel?.channelDescription}</ModalHeader>
        <ModalBody>
          <img src={selectedChannel?.attachment} className="w-100" />
        </ModalBody>
      </Modal>
    </>
  );
};

export default LiveChatModal;